import LegalPage from "../components/LegalPage";

const AffiliateDisclosurePage = () => (
    <LegalPage
        title="Affiliate Disclosure"
        eyebrow="Transparency"
        updated="28 September 2026"
        description="How SahiKhoj uses outbound and affiliate links, how we may earn commissions, and how this does (not) affect what you see."
        path="/affiliate-disclosure"
        testId="affiliate-disclosure"
        intro="SahiKhoj helps you compare prices, offers, coupons, flights and hotels across platforms. Some links on this website and in the SahiKhoj app take you to third-party stores or booking sites, and we may earn a commission when you buy or book through them."
        sections={[
            {
                heading: "What affiliate links are",
                body: [
                    "An affiliate link is a link to a store or booking platform that contains a tracking reference. If you make a qualifying purchase or booking after following such a link, the merchant may pay SahiKhoj a commission. This is a common way for free comparison services to fund their work.",
                    "Not every outbound link on SahiKhoj is currently an affiliate link. Where affiliate tracking is active, it is handled by a central link system, and this page will continue to describe the relationship honestly as the programme evolves.",
                ],
            },
            {
                heading: "You never pay more",
                body: [
                    "A commission, where one applies, is paid by the merchant — never added to your price. The price you pay through a SahiKhoj link is the same as the price you would pay by visiting the store directly, and in some cases a coupon or offer we list may make it lower.",
                ],
            },
            {
                heading: "How this affects what you see",
                body: [
                    "Comparison results — prices, stores, availability — come from the respective platforms' listing data and are shown as received. Whether a merchant has an affiliate relationship with SahiKhoj does not decide whether or where it appears in comparison results.",
                    "Editorial content on the SahiKhoj blog is written to be useful first. Articles that contain outbound merchant links carry a disclosure note on the article itself. Our recommendations are not sold, and merchants cannot pay to be described as 'best' in editorial content.",
                ],
            },
            {
                heading: "Prices and availability can change",
                body: [
                    "Prices, discounts, coupon validity, flight fares and hotel rates shown on SahiKhoj reflect what the respective platform showed at the time of lookup and can change at any moment. Always confirm the final payable amount, terms and availability on the merchant or booking site before paying. SahiKhoj does not sell products or issue tickets itself.",
                ],
            },
            {
                heading: "Third-party websites",
                body: [
                    "When you follow a link from SahiKhoj you leave our service. Purchases, bookings, returns, warranties and customer service for those transactions are handled entirely by the merchant or booking platform under its own terms and privacy policy.",
                ],
            },
            {
                heading: "Questions",
                body: [
                    "If anything about how a link or recommendation works is unclear, write to us — we would rather explain than have you guess. Our editorial standards are described on the Editorial Policy page.",
                ],
            },
        ]}
    />
);

export default AffiliateDisclosurePage;
